module.exports = __webpack_public_path__ + "fonts/AmbulatoriaD-Light.5d4d8d45.woff2";